import {ZIDXFormField} from "../form/FormField.js";
import {ZIDXFormFieldType} from "../form/FormFieldType.js";

export class ZIDXFileFormField extends ZIDXFormField{
    downloadPath:string="";
    uploadPath:string="";
    constructor(){
        super();
        this.type= ZIDXFormFieldType.FILE;
    }
}